/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import ActivityProcess from './components/RopaDetail/components/Activity';
import Secret from './components/RopaDetail/components/Secret';
import Detail from './components/RopaDetail/Detail';
import TabsDetail from './components/RopaDetailView/Tabs';
import RopaService from '../../services/Ropa.service';
import DataFlowService from '../../services/DataFlow.service';
import UserService from '../../services/UserService';
import { STATUS_ID } from './STATUS_ID';
import Risk from './components/RopaDetail/components/Risk';
import { ROUTER } from '../../constants/router';
import Comment from '../data-flow/components/Comment';
import usePermission from '../../hooks/usePermission';

export default function RopaDetailView() {
    const { t } = useTranslation();
    let navigate = useNavigate();
    let { activityId, menu, tab, dsrTaskId } = useParams();

    const [detail, setDetail] = useState();
    const [detailInfo, setDetailInfo] = useState();
    const [editMode, setEditMode] = useState(false);
    const [openTabDB, setOpenTabDB] = useState(false);
    const [storageLocation, setStorageLocation] = useState([]);

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const [permission, setPermission] = useState(true);
    const { isAuditor } = usePermission();

    const [currentUser, setCurrentUser] = useState();

    useEffect(() => {
        getRopaDetail();
        getRoPaDetailHeader();
        getMasterStorageLocation();
    }, [activityId]);

    const getRoPaDetailHeader = async () => {
        try {
            const { data } = await RopaService.getRoPaDetailHeader(activityId);
            if (data?.resultData) {
                setDetailInfo(data.resultData);
                getDataFlowPermission(data?.resultData?.businessProcessId);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (isAuditor) {
            setEditMode(false);
            return;
        }

        if (menu) {
            setEditMode(false);
        } else {
            if (detailInfo) {
                if (admin) {
                    if (
                        detailInfo.statusId === STATUS_ID.WAITING_FOR_REVIEW ||
                        detailInfo.statusId === STATUS_ID.DRAFT ||
                        detailInfo.statusId === STATUS_ID.REVISE
                    ) {
                        //Waiting for Review
                        setEditMode(true);
                    } else {
                        setEditMode(false);
                    }
                } else {
                    //Waiting for Review and Reviewed
                    if (
                        detailInfo.statusId === STATUS_ID.WAITING_FOR_REVIEW ||
                        detailInfo.statusId === STATUS_ID.REVIEWED
                    ) {
                        setEditMode(false);
                    } else {
                        setEditMode(true);
                    }
                }
            }
        }
    }, [admin, detailInfo]);

    const getRopaDetail = async () => {
        try {
            const { data } = await RopaService.getRopaDetail(activityId);

            if (data?.resultData) {
                setDetail(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getMasterStorageLocation = async () => {
        try {
            const { data } = await RopaService.getMasterStorageLocation(
                activityId
            );
            if (data?.resultData) {
                setStorageLocation(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (detail && storageLocation.length > 0) {
            detail?.collectDataDestruction?.storageLocation?.forEach((e) => {
                if (e) {
                    const result = storageLocation.filter(
                        (data) => data.id === e
                    );
                    if (result?.length > 0) {
                        if (result[0].name === 'Database (ฐานข้อมูล)') {
                            setOpenTabDB(true);
                        }
                    }
                }
            });
        }
    }, [detail, storageLocation]);

    const getDataFlowPermission = async (businessProcessId) => {
        try {
            const { data } = await DataFlowService.getDataFlowPermission(
                businessProcessId
            );
            if (data?.resultData) {
                setPermission(data?.resultData?.accessPermission);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getUserId = async () => {
        try {
            const user = UserService.getUi();
            if (user) {
                setCurrentUser(user);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getDataFlowPermission();
        getUserId();
    }, []);

    return (
        <div>
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        if (menu === 'ra') {
                            navigate(ROUTER.RISK_MANAGEMENT.RA);
                        } else if (menu === 'rr') {
                            navigate(ROUTER.RISK_MANAGEMENT.RR);
                        } else if (menu === 'ropa') {
                            navigate(
                                `${ROUTER.DS_360.MY_TASK}/${tab}/${dsrTaskId}`
                            );
                        } else {
                            navigate(ROUTER.DS_INVENTORY.ROPA);
                        }
                    }}
                >
                    <IconBack />
                </button>
                {t('RoPA.RecordOfProcessingActivityDetail')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} /{' '}
                    {t('RoPA.RecordOfProcessingActivity')} /{' '}
                </span>
                <span>{t('RoPA.RecordOfProcessingActivityDetail')}</span>
            </div>
            {permission ? (
                <div className="mt-6">
                    <Detail
                        detailInfo={detailInfo}
                        detail={detail}
                        getRoPaDetailHeader={getRoPaDetailHeader}
                        secretLevelId={detailInfo?.secretLevelId}
                    />
                    <div className="grid grid-cols-3 gap-4">
                        <TabsDetail
                            detail={detail}
                            editMode={editMode}
                            openTabDB={openTabDB}
                            storageLocation={storageLocation}
                            currentUser={currentUser}
                            detailInfo={detailInfo}
                        />
                        <div>
                            {detailInfo?.comment && (
                                <Comment comment={detailInfo?.comment} />
                            )}
                            <div
                                hidden={
                                    detailInfo?.statusId !== STATUS_ID.REVISE
                                }
                                className="bg-[#FFECF0] p-4 mt-4 rounded-xl"
                            >
                                <div className="text-[#F0536F] font-semibold text-sm">
                                    {t('RR.ReasonForRevise')}
                                </div>
                                <div className="my-4 border-2 border-solid border-[#FFCFD8]"></div>
                                <div>{detailInfo?.reason}</div>
                            </div>
                            <Risk
                                editMode={editMode}
                                detail={detail}
                                detailInfo={detailInfo}
                            />
                            <Secret
                                editMode={editMode}
                                secretLevelId={detailInfo?.secretLevelId}
                                getRoPaDetailHeader={() =>
                                    getRoPaDetailHeader(activityId)
                                }
                            />
                            <ActivityProcess
                                activityId={activityId}
                                getRopaDetail={getRopaDetail}
                                getRoPaDetailHeader={getRoPaDetailHeader}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="flex items-center justify-center flex-col h-[70vh]">
                    <svg
                        width="318"
                        height="180"
                        viewBox="0 0 318 180"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_111_72273)">
                            <path
                                d="M133.137 161.118H204.399C207.212 161.118 207.217 156.742 204.399 156.742H133.137C130.323 156.742 130.319 161.118 133.137 161.118Z"
                                fill="#E6E6E6"
                            />
                            <path
                                d="M245.855 19.5508V96.8279H121.639V70C121.637 68.4551 118.091 62.0924 117 61C115.909 59.9076 109.543 56.9792 108 56.9777H92.5215V19.5508H245.855Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M152.016 80.5227H193.311C193.71 80.5205 194.102 80.4141 194.448 80.2137C194.795 80.0133 195.084 79.7259 195.288 79.3792C195.492 79.0326 195.603 78.6386 195.612 78.2356C195.62 77.8325 195.525 77.4341 195.336 77.0791L174.699 38.3531C174.501 37.9819 174.207 37.6716 173.849 37.4554C173.49 37.2392 173.081 37.125 172.663 37.125C172.246 37.125 171.836 37.2392 171.478 37.4554C171.12 37.6716 170.826 37.9819 170.628 38.3531L149.981 77.0791C149.791 77.4349 149.696 77.8342 149.705 78.2381C149.714 78.642 149.827 79.0367 150.032 79.3836C150.237 79.7305 150.527 80.0178 150.875 80.2175C151.223 80.4171 151.616 80.5223 152.016 80.5227ZM175.291 73.4463H170.036V68.1415H175.291V73.4463ZM175.291 64.6033H170.036V53.9913H175.291V64.6033Z"
                                fill="white"
                            />
                            <path
                                d="M253.524 107.719H121.777V107.18H252.986V16.1711C252.985 15.1003 252.56 14.0737 251.803 13.3166C251.047 12.5594 250.021 12.1335 248.951 12.1323H87.8163C86.7465 12.1335 85.7208 12.5594 84.9644 13.3166C84.2079 14.0737 83.7824 15.1003 83.7812 16.1711V56.6256H83.2432V16.1711C83.2445 14.9576 83.7268 13.7941 84.5841 12.9359C85.4414 12.0778 86.6038 11.5951 87.8163 11.5938H248.951C250.164 11.5951 251.326 12.0778 252.183 12.9359C253.041 13.7941 253.523 14.9576 253.524 16.1711V107.719Z"
                                fill="#3F3D56"
                            />
                            <rect
                                x="34.457"
                                y="56.7031"
                                width="87.3072"
                                height="104.165"
                                rx="16.0346"
                                fill="#F9FAFE"
                                stroke="#3F3D56"
                                stroke-width="0.5"
                            />
                            <path
                                d="M241.041 124.147H121.777V123.608H241.041C244.208 123.605 247.244 122.344 249.484 120.102C251.723 117.861 252.983 114.822 252.986 111.652V107.722H121.777V107.184H253.524V111.652C253.521 114.965 252.204 118.141 249.864 120.483C247.524 122.826 244.351 124.143 241.041 124.147Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M205.645 150.531C198.997 144.141 194.623 135.804 193.217 124.144H144.217C143.718 135.052 139.372 143.233 131.533 150.503L130.705 150.531C138.793 143.195 143.248 134.954 143.69 123.864L143.701 123.605H193.696L193.723 123.844C195.104 135.701 199.569 144.092 206.382 150.488L205.645 150.531Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M77.9457 63.3744C77.5849 63.3744 77.2323 63.2673 76.9323 63.0667C76.6323 62.866 76.3985 62.5809 76.2604 62.2472C76.1224 61.9136 76.0863 61.5465 76.1566 61.1923C76.227 60.8382 76.4007 60.5128 76.6558 60.2575C76.911 60.0021 77.236 59.8282 77.5898 59.7577C77.9437 59.6873 78.3104 59.7234 78.6438 59.8616C78.9771 59.9998 79.262 60.2338 79.4624 60.5341C79.6629 60.8343 79.7699 61.1873 79.7699 61.5485C79.7693 62.0325 79.577 62.4966 79.235 62.8389C78.893 63.1813 78.4294 63.3738 77.9457 63.3744ZM77.9457 60.1447C77.6683 60.1447 77.3972 60.227 77.1665 60.3813C76.9359 60.5355 76.7561 60.7548 76.65 61.0113C76.5438 61.2678 76.5161 61.5501 76.5702 61.8224C76.6243 62.0947 76.7579 62.3449 76.954 62.5412C77.1502 62.7375 77.4001 62.8712 77.6721 62.9254C77.9442 62.9795 78.2262 62.9517 78.4825 62.8455C78.7388 62.7392 78.9578 62.5593 79.1119 62.3284C79.266 62.0975 79.3482 61.8261 79.3482 61.5485C79.3478 61.1763 79.1999 60.8195 78.937 60.5563C78.674 60.2931 78.3176 60.1451 77.9457 60.1447Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M77.9458 159.609C77.4854 159.609 77.0354 159.472 76.6526 159.216C76.2699 158.96 75.9715 158.596 75.7953 158.171C75.6192 157.745 75.5731 157.276 75.6629 156.825C75.7527 156.373 75.9744 155.957 76.2999 155.632C76.6254 155.306 77.0401 155.084 77.4916 154.994C77.9431 154.904 78.4111 154.95 78.8365 155.127C79.2618 155.303 79.6253 155.601 79.8811 155.985C80.1368 156.368 80.2733 156.818 80.2734 157.279C80.2727 157.897 80.0272 158.489 79.5909 158.926C79.1545 159.362 78.5629 159.608 77.9458 159.609ZM77.9458 155.488C77.5918 155.488 77.2458 155.593 76.9515 155.79C76.6572 155.986 76.4278 156.266 76.2924 156.594C76.1569 156.921 76.1215 157.281 76.1906 157.628C76.2596 157.976 76.4301 158.295 76.6804 158.546C76.9306 158.796 77.2495 158.967 77.5967 159.036C77.9438 159.105 78.3036 159.069 78.6307 158.934C78.9577 158.798 79.2371 158.569 79.4338 158.274C79.6304 157.98 79.7354 157.633 79.7354 157.279C79.7348 156.804 79.5461 156.349 79.2106 156.013C78.8751 155.677 78.4202 155.488 77.9458 155.488Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M309.04 161.891H10.405C10.3674 161.891 10.3301 161.884 10.2953 161.869C10.2605 161.855 10.2289 161.833 10.2022 161.806C10.1756 161.779 10.1544 161.747 10.14 161.712C10.1256 161.676 10.1182 161.638 10.1182 161.6C10.1182 161.562 10.1256 161.524 10.14 161.488C10.1544 161.453 10.1756 161.421 10.2022 161.394C10.2289 161.367 10.2605 161.345 10.2953 161.33C10.3301 161.316 10.3674 161.308 10.405 161.309H309.04C309.078 161.308 309.115 161.316 309.15 161.33C309.185 161.345 309.217 161.367 309.243 161.394C309.27 161.421 309.291 161.453 309.305 161.488C309.32 161.524 309.327 161.562 309.327 161.6C309.327 161.638 309.32 161.676 309.305 161.712C309.291 161.747 309.27 161.779 309.243 161.806C309.217 161.833 309.185 161.855 309.15 161.869C309.115 161.884 309.078 161.891 309.04 161.891Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M205.812 161.574H131.297C130.555 161.575 129.82 161.429 129.134 161.145C128.448 160.861 127.825 160.445 127.3 159.92C126.775 159.395 126.358 158.771 126.074 158.085C125.79 157.399 125.644 156.663 125.644 155.92C125.644 155.177 125.79 154.441 126.074 153.755C126.358 153.069 126.775 152.445 127.3 151.92C127.825 151.395 128.448 150.979 129.134 150.695C129.82 150.411 130.555 150.265 131.297 150.266H205.812C207.31 150.267 208.745 150.863 209.804 151.923C210.862 152.984 211.457 154.421 211.457 155.92C211.457 157.419 210.862 158.856 209.804 159.917C208.745 160.977 207.31 161.573 205.812 161.574ZM131.297 150.804C129.942 150.804 128.642 151.343 127.683 152.303C126.725 153.262 126.186 154.563 126.186 155.92C126.186 157.277 126.725 158.578 127.683 159.538C128.642 160.497 129.942 161.036 131.297 161.036H205.812C207.168 161.036 208.468 160.497 209.426 159.538C210.385 158.578 210.923 157.277 210.923 155.92C210.923 154.563 210.385 153.262 209.426 152.303C208.468 151.343 207.168 150.804 205.812 150.804H131.297Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M259.917 118.522L262.004 122.889L279.827 116.911L276.746 110.465L259.917 118.522Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M261.977 133.25L255.418 119.524L260.716 116.988L264.935 125.816C265.556 127.115 265.635 128.607 265.157 129.965C264.678 131.323 263.68 132.435 262.382 133.056L261.977 133.25Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M255.716 157.521L260.55 157.357L260.753 138.523L255.087 138.858L255.716 157.521Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M269.929 161.793H254.728V155.914H264.505C265.943 155.914 267.323 156.486 268.34 157.505C269.357 158.523 269.929 159.904 269.929 161.343V161.793Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M256.113 154.694C255.708 154.694 255.314 154.558 254.995 154.307C254.676 154.057 254.45 153.707 254.353 153.313C251.705 142.664 241.852 89.0068 250.565 78.4685L250.641 78.3766L250.756 78.3474C251.368 78.1924 262.898 74.6193 269.664 80.1966L269.743 80.2618L273.508 91.1714L283.658 106.253C284.214 107.079 284.598 108.008 284.789 108.985C284.979 109.963 284.972 110.968 284.767 111.943C284.562 112.917 284.164 113.841 283.596 114.658C283.028 115.476 282.301 116.171 281.46 116.702L268.131 125.121C267.809 125.316 267.435 125.406 267.06 125.38C266.685 125.353 266.327 125.211 266.035 124.974C265.791 124.771 265.602 124.508 265.489 124.211L262.688 117.202C262.521 116.777 262.518 116.305 262.68 115.878C262.842 115.451 263.157 115.1 263.564 114.893L269.809 111.768C269.98 111.674 270.128 111.543 270.243 111.385C270.359 111.228 270.438 111.047 270.476 110.855C270.493 110.682 270.468 110.507 270.402 110.345C270.337 110.184 270.234 110.04 270.101 109.928L262.852 103.673C262.691 103.534 262.493 103.445 262.282 103.417C262.071 103.389 261.856 103.423 261.664 103.515C261.473 103.608 261.312 103.754 261.202 103.937C261.092 104.119 261.038 104.33 261.046 104.543L262.843 152.026C262.86 152.472 262.713 152.908 262.43 153.253C262.147 153.597 261.747 153.826 261.307 153.896L256.404 154.671C256.308 154.686 256.211 154.694 256.113 154.694Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M268.618 82.13C268.577 82.13 268.536 82.1285 268.495 82.1254L250.417 80.7851C250.166 80.7668 249.923 80.691 249.706 80.5634C249.489 80.4357 249.305 80.2598 249.167 80.0492C249.029 79.8386 248.941 79.599 248.911 79.349C248.88 79.0991 248.908 78.8454 248.991 78.6078C250.103 75.3988 250.24 71.9318 249.383 68.6452C248.206 63.9985 248.178 55.3586 248.266 50.6221C248.286 49.8191 248.608 49.0532 249.167 48.4772C249.726 47.9011 250.482 47.5573 251.283 47.5142L251.283 47.5078L251.648 47.5123C254.593 47.5536 259.997 47.7639 264.419 48.6849C265.91 48.9936 267.25 49.8011 268.221 50.9743C269.192 52.1475 269.735 53.6166 269.76 55.1397C269.86 59.5371 269.875 65.4893 269.377 68.8728C268.956 71.7272 269.733 77.2089 270.233 80.2224C270.272 80.4571 270.259 80.6974 270.196 80.9267C270.133 81.156 270.02 81.3687 269.867 81.5502C269.713 81.7317 269.522 81.8776 269.306 81.9777C269.091 82.0778 268.856 82.1298 268.618 82.13H268.618Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M275.072 99.3787C274.59 99.1479 274.165 98.8141 273.826 98.401C273.487 97.9879 273.243 97.5055 273.111 96.9877C272.978 96.4699 272.961 95.9294 273.06 95.4041C273.159 94.8789 273.372 94.3818 273.683 93.9478L265.334 57.9102H271.646L279.015 93.2375C279.709 93.8098 280.168 94.617 280.307 95.506C280.446 96.3951 280.254 97.3042 279.768 98.0612C279.282 98.8182 278.536 99.3704 277.67 99.6133C276.804 99.8561 275.88 99.7726 275.072 99.3787H275.072Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M235.529 61.8161L245.525 52.3516L249.291 57.6286L239.876 65.9211L252.223 75.735C252.312 75.7289 252.401 75.7214 252.492 75.7214C253.251 75.7207 253.995 75.939 254.634 76.3504C255.273 76.7617 255.78 77.3486 256.095 78.0409C256.409 78.7332 256.518 79.5014 256.408 80.2539C256.297 81.0063 255.973 81.7109 255.473 82.2836C254.973 82.8562 254.319 83.2725 253.589 83.4827C252.858 83.693 252.083 83.6882 251.356 83.469C250.628 83.2498 249.979 82.8254 249.486 82.2467C248.993 81.6679 248.678 80.9593 248.576 80.2056L248.538 80.2446L235.687 69.0973C235.169 68.6479 234.751 68.095 234.46 67.474C234.168 66.853 234.01 66.1778 233.995 65.4918C233.98 64.8059 234.109 64.1244 234.373 63.4913C234.637 62.8582 235.031 62.2876 235.529 61.8161Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M265.999 60.2182C265.69 60.2191 265.387 60.1321 265.126 59.9672C264.864 59.8023 264.655 59.5663 264.523 59.2869C263.726 57.6038 263.178 55.8139 262.895 53.9733C262.461 50.9668 264.55 49.1782 266.674 48.7886C268.74 48.4095 271.257 49.3187 271.9 52.2104C271.954 52.4552 271.996 52.7025 272.025 52.9515C272.282 55.1436 272.525 56.8484 272.745 58.019C272.788 58.2492 272.782 58.486 272.726 58.7134C272.67 58.9408 272.566 59.1536 272.421 59.3375C272.276 59.5213 272.094 59.6719 271.886 59.7792C271.678 59.8865 271.449 59.9479 271.215 59.9593L266.083 60.216C266.055 60.2175 266.027 60.2182 265.999 60.2182Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M258.842 44.4085C264.879 44.4085 269.772 39.5103 269.772 33.4679C269.772 27.4256 264.879 22.5273 258.842 22.5273C252.805 22.5273 247.912 27.4256 247.912 33.4679C247.912 39.5103 252.805 44.4085 258.842 44.4085Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M258.908 45.2657C263.85 45.2657 267.856 41.2555 267.856 36.3086C267.856 31.3618 263.85 27.3516 258.908 27.3516C253.965 27.3516 249.959 31.3618 249.959 36.3086C249.959 41.2555 253.965 45.2657 258.908 45.2657Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M243.025 55.862C242.797 55.6537 242.632 55.3846 242.551 55.0863C242.469 54.7879 242.474 54.4725 242.565 54.1769C243.114 52.3974 243.918 50.7071 244.952 49.1587C246.662 46.649 249.409 46.7429 251.238 47.892C253.017 49.0098 254.258 51.3819 252.781 53.9488C252.655 54.1658 252.519 54.3763 252.372 54.5795C251.083 56.3697 250.11 57.7905 249.483 58.8026C249.359 59.0016 249.195 59.1717 249 59.3016C248.805 59.4315 248.585 59.5181 248.354 59.5556C248.123 59.5931 247.887 59.5807 247.661 59.5191C247.435 59.4575 247.225 59.3482 247.045 59.1985L243.088 55.9171C243.067 55.8992 243.046 55.8808 243.025 55.862Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M256.719 23.7C254.519 22.3864 254.043 19.1152 255.353 16.9125C256.664 14.7098 259.312 13.5608 261.872 13.485C265.529 13.3769 269.061 15.1994 271.621 17.8157C274.18 20.432 275.869 23.781 277.156 27.2088C278.444 30.6366 279.368 34.1918 280.636 37.6267C281.287 39.3892 282.088 41.199 283.577 42.3436C285.066 43.4882 287.433 43.6946 288.706 42.3133C288.701 44.5237 287.008 46.5331 284.908 47.2174C282.808 47.9018 280.433 47.385 278.592 46.164C275.399 44.0457 273.857 40.179 272.975 36.4472C272.094 32.7155 271.66 28.8051 269.888 25.4053C269.154 23.9967 268.148 22.6586 266.732 21.9399C265.317 21.2211 263.431 21.2683 262.292 22.3752C261.765 22.8879 261.423 23.587 260.825 24.0143C260.446 24.2514 260.018 24.3987 259.574 24.445C259.129 24.4914 258.68 24.4354 258.261 24.2815C257.426 23.9671 256.644 23.5255 255.943 22.9723"
                                fill="#2F2E41"
                            />
                            <path
                                d="M249.562 30.2595C250.425 31.4202 251.513 32.394 252.762 33.1224C254.01 33.8509 255.393 34.3188 256.827 34.4979C258.261 34.6771 259.716 34.5638 261.105 34.1649C262.494 33.766 263.788 33.0897 264.909 32.1769C265.778 31.4693 266.585 30.4941 266.531 29.3743C266.475 28.2272 265.538 27.3263 264.582 26.6919C262.066 25.0367 259.04 24.3408 256.055 24.7308C254.351 24.9599 252.643 25.5813 251.437 26.8066C250.23 28.032 249.629 29.9377 250.251 31.5413"
                                fill="#2F2E41"
                            />
                            <rect
                                x="40.4009"
                                y="66.6641"
                                width="76.1481"
                                height="86.4306"
                                rx="13.5705"
                                fill="#7B67FB"
                            />
                            <path
                                d="M57.6501 131.577H98.9452C99.3444 131.575 99.7362 131.469 100.083 131.268C100.429 131.068 100.718 130.781 100.922 130.434C101.126 130.087 101.237 129.693 101.246 129.29C101.254 128.887 101.159 128.489 100.97 128.134L80.3328 89.4078C80.135 89.0365 79.8414 88.7263 79.483 88.5101C79.1247 88.2939 78.7151 88.1797 78.2977 88.1797C77.8802 88.1797 77.4706 88.2939 77.1123 88.5101C76.754 88.7263 76.4603 89.0365 76.2625 89.4078L55.615 128.134C55.4255 128.49 55.3305 128.889 55.3394 129.293C55.3484 129.697 55.4608 130.091 55.6658 130.438C55.8709 130.785 56.1614 131.073 56.5092 131.272C56.857 131.472 57.2501 131.577 57.6501 131.577ZM80.9251 124.501H75.6702V119.196H80.9251V124.501ZM80.9251 115.658H75.6702V105.046H80.9251V115.658Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_111_72273">
                                <rect
                                    width="299.209"
                                    height="150.327"
                                    fill="white"
                                    transform="translate(10.1182 11.5625)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                    <p className="font-medium text-3xl text-gray-dark pt-8">
                        {t('You dont have permission to access')}
                    </p>
                </div>
            )}
        </div>
    );
}
